import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronIcon, CheckIcon } from './icons';
export const FAQ: React.FC = () => {
  const faqs = [{
    q: 'I am very busy. How much time does this take?',
    a: "Exactly 10 minutes or less. We designed this for busy professionals. Our 'Ice Cube' hack lets you prep for the whole week in one Sunday session."
  }, {
    q: 'Is this only for raw feeders?',
    a: "Not at all. This works whether you feed kibble, canned, or cooked food. We show you how to 'Biohack' whatever is currently in the bowl."
  }, {
    q: 'My dog is already 10 years old. Is it too late?',
    a: 'It is never too late to reduce inflammation. Senior dogs often show the most dramatic improvements in energy and mobility within the first 14 days.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-6 sm:px-8 lg:px-12 max-w-3xl mx-auto border-t border-gold/30" data-id="element-26">
      <div className="text-center mb-12" data-id="element-27">
        <span className="text-xs font-bold tracking-[0.2em] text-gold uppercase block mb-4" data-id="element-28">
          Common Questions
        </span>
        <h2 className="font-serif text-3xl sm:text-4xl text-forest-dark" data-id="element-29">
          Everything you need to know.
        </h2>
      </div>

      <div className="space-y-4" data-id="element-30">
        {faqs.map((faq, i) => <div key={i} className="bg-white rounded-xl border border-gold/20 overflow-hidden shadow-sm" data-id="element-31">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-32">
              <span className="font-bold text-forest-dark pr-4" data-id="element-33">{faq.q}</span>
              <motion.div animate={{
            rotate: openIndex === i ? 180 : 0
          }} transition={{
            duration: 0.2
          }} className="shrink-0" data-id="element-34">
                <ChevronIcon className="w-5 h-5 text-gold" data-id="element-35" />
              </motion.div>
            </button>

            <AnimatePresence data-id="element-36">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-37">
                  <div className="px-6 pb-6 pt-0 flex items-start gap-3" data-id="element-38">
                    <CheckIcon className="w-5 h-5 text-forest shrink-0 mt-0.5" data-id="element-39" />
                    <p className="text-charcoal/80 text-sm sm:text-base leading-relaxed" data-id="element-40">
                      {faq.a}
                    </p>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </section>;
};